import React, { useEffect, useRef, useState } from 'react';
import { Card, Col, Container, Form, Nav, Row } from 'react-bootstrap';
import { Button, ColorPicker, Dialog, InputNumber, InputTextarea, SelectButton, } from 'primereact';
import "./theme.css"
import { Stepper } from 'primereact/stepper';
import { StepperPanel } from 'primereact/stepperpanel';
import {
  BUSCAR_CODIGO_EXISTENCIA, CantidadTabletasPOSResturante,
  CONFIGURACION_OPCIONALES_FORMALIZACION_ACADEMICA,
  FECHA_CIERRE_FISCAL,
  FormHelper,
  getComponentWithLoading,
  integracionComernioElectronico,
  integracionesDgii,
  integracionesPanelFirma,
  integracionLinkPago,
  modulosAdi,
  otrasConfig,
  PhoneFormat,
  PLAN_REFERIDO,
  PLANES_ECF,
  PROCESAR_PAGO_TC,
  TIPO_NCF_DO,
  tiposPago,
  USUARIO_LOGIN,
  VALIDAR_REFERENCIA_CLIENTE
} from '../../Utils/index';
import InputContainer from "../PantallasEdit/InputContainer/InputContainer";
import EditSection from "../PantallasEdit/EditSection/EditSection";
import { DropZone } from "../DropZone/Dropzone";
import SectionRow from "../PantallasEdit/SectionRow/SectionRow";
import { RncLookup } from "../Lookups/RncLookup";
import { ControlledInput } from "../Inputs/ControlledInput";
import Select from "react-select";
import { ActividadEconomicaLookup } from "../Lookups/ActividadEconomicaLookup";
import Direcciones from "../Direcciones/Direcciones";
import { buscar } from "../../Utils/Buscar";
import { useConfirm } from "../../Hooks";
import useMessage from "../../Hooks/useMessage";
import { Compania, COSTO_LICENCIA, COSTO_LICENCIA_ACADEMICA, COSTO_MODULOS_ADICIONALES } from "../../Models/Compania";
import { PhoneInput } from "../PhoneInput/PhoneInput";
import { EmailInput } from "../EmailInput/EmailInput";

function Formalizar({ showLoading, hideLoading }) {
  const [pagosUnicos, setPagosUnicos] = useState(0)
  const stepperRef = useRef(null);
  const codigoInputRef = useRef(null);

  var EsReferido = window.EsReferido;
  var ReferidoPor = window.ReferidoPorNombre;
  const [compania, setCompania] = useState(new Compania());
  const [esNuevo, setEsNuevo] = useState(true);

  const [pagoAnual, setPagoAnual] = useState(false);
  const [subTotal, setSubtotal] = useState(0);
  const fileUploadRefRecurrente = useRef(null);
  const fileUploadRefTransferencia = useRef(null);

  const [totalLicencia, setTotalLicencia] = useState(0);
  const [totalModulos, setTotalModulos] = useState(0);
  const [totalIntegraciones, setTotalIntegraciones] = useState(0);

  const [descuentoAnual, setDescuentoAnual] = useState(0);
  const [montoAnual, setMontoAnual] = useState(0);
  const [modulosAdicionales, setModulosAdicionales] = useState([]);
  const [intDgii, setIntDgii] = useState([]);
  const [tipoPlan, setTipoPlan] = useState(['1kT']);

  const [configOpcionalesAcadmico, setConfigOpcionalesAcademico] = useState([]);
  const { Confirm, Types } = useConfirm();

  const [intPanelFirma, setIntPanelFirma] = useState([]);
  const [intComercioElectronico, setIntComercionElectronico] = useState([]);
  const [intLinkPago, setIntLinkPago] = useState([]);
  const [otrasConfiguraciones, setOtrasConfiguraciones] = useState([]);
  const consultaActualId = useRef();
  const [tipoPago, setTipoPago] = useState([])
  const [visible, setVisible] = useState(false);
  const [pagoModalVisible, setPagoModalVisible] = useState(false);
  const [body, setBody] = useState(null);
  const [header, setHeader] = useState(null)
  const [dropZoneKey, setDropZoneKey] = useState("dropZone - first");
  const [montDescuentoReferencia, setMontoDescuentoReferencia] = useState(0);
  const [escenario, setEscenario] = useState(null);
  const { Error, Message, Warning, cerrarAlertas } = useMessage();
  const [canvasPosicion, setCanvasPosicion] = useState('end')
  const [tipoPlanReferido, setTipoPlanReferido] = useState(1)
  const [codigoPrueba, setCodigoPrueba] = useState("");

  const [descuentoCantidadLicencias, setDescuentoCantidadLicencias] = useState(0)
  const [cantidadDispositivosPosRestaurante, setCantidadDispositovsPosRestaurante] = useState(0);
  useEffect(() => {
    const obtenerDatos = () => {
      const consultaId = Math.random();
      consultaActualId.current = consultaId;

      const url = USUARIO_LOGIN;
      try {
        buscar(url, {}).then((data) => {
          if (consultaId === consultaActualId.current) {
            if (data.companiaSimple) {
              if (!data.companiaSimple.EsCompaniaPrueba && !data.companiaSimple.EsUsuarioProceso && data.companiaSimple.Estatus === "A" && params.get('Esc') !== '4') {
                Message({ messages: ["Para iniciar este proceso, por favor, cierre la sesión que tiene actualmente abierta en el sistema. Luego recargue la página."] })
              } else {
                setEsNuevo(false);
                var txtCompaniaId = document.getElementById("ContentPH_ucCitrusFormalizarPagoEnLinea_txtCompaniaId");
                txtCompaniaId.value = data.companiaSimple.Id

                if (data.companiaSimple.EsCompaniaPrueba) {
                  setCodigoPrueba(data.companiaSimple.Codigo);
                  data.companiaSimple.Codigo = "";
                  setCompania(data.companiaSimple)
                } else {
                  setCompania(data.companiaSimple);
                  setCodigoPrueba("");
                }
              }
            } else {
              setCompania({
                ...compania,
                Direcciones: [{
                  DireccionCalle: "",
                  DireccionNumero: "",
                  DireccionProvincia: 0,
                  DireccionMunicipio: 0,
                  DireccionBarrio: 0,
                  DireccionSubBarrio: 0,
                  Latitud: "",
                  Longitud: "",
                  DireccionLinea1: "",
                  DireccionLinea2: "",
                }],
                Telefonos: [{
                  Telefono: "", Extension: "", Tipo: "F"
                }],
                TelefonoCobro: [{
                  Telefono: "", Extension: "", Tipo: "F"
                }, { Telefono: "", Extension: "", Tipo: "F" }],
                CorreoCobro: ""
              })
            }
          }
        }).catch((err) => {
          if (params.get('Esc') !== '3' && params.get('Esc') !== '4') {
            setVisible(true);
          } else {
            setCompania({
              ...compania,
              Direcciones: [{
                DireccionCalle: "",
                DireccionNumero: "",
                DireccionProvincia: 0,
                DireccionMunicipio: 0,
                DireccionBarrio: 0,
                DireccionSubBarrio: 0,
                Latitud: "",
                Longitud: "",
                DireccionLinea1: "",
                DireccionLinea2: "",
              }],
              Telefonos: [{
                Telefono: "", Extension: "", Tipo: "F"
              }],
              TelefonoCobro: [{
                Telefono: "", Extension: "", Tipo: "F"
              }, { Telefono: "", Extension: "", Tipo: "F" }],
              CorreoCobro: ""
            })
          }
        })
      } catch (e) {
      }
    };
    const params = new URLSearchParams(window.location.search);
    setEscenario(params.get('Esc'))
    if (!params.has("Esc")) {
      setVisible(true);
    } else {
      obtenerDatos()
    }


  }, []);
  useEffect(() => {
    switch (escenario) {
      case "3":
        Message({ messages: ['Favor llene los campos con la información necesaria, estos serán los datos de su cuenta.'] })
        break;
      case "2":
        Message({ messages: ['Su tiempo de prueba ha finalizado. Ahora el siguiente paso es Formalizar...'] })
        break;
      case "1":
        Message({ messages: ['Por favor llenar y/o modificar los campos requeridos.'] })
        break;
    }
  }, [escenario])
  useEffect(() => {
    calculateTotal(pagoAnual, EsReferido);
  }, [
    compania.licencias,
    compania.licenciasCRM,
    modulosAdicionales,
    intDgii,
    intPanelFirma,
    intComercioElectronico,
    intLinkPago,
    pagoAnual,
    tipoPlan,
    tipoPlanReferido,
    cantidadDispositivosPosRestaurante,
  ]);
  function setWindowVariables() {
    var txtCodigo = document.getElementById("ContentPH_ucCitrusFormalizarPagoEnLinea_txtCodigo");
    var luRncCia = document.getElementById("ContentPH_ucCitrusFormalizarPagoEnLinea_luRncCia");
    var txtNombre = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_txtNombre');
    var txtLicencias = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_txtLicencias');
    var txtLicenciasCRM = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_txtLicenciasCRM');
    var txtLicenciasPT = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_txtLicenciasPT');
    var txtRazon = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_txtRazon');
    var txtDireccion = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_txtDireccion');
    var txtCorreoElectronico = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_txtCorreoElectronico');
    var txtTelefono = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_txtTelefono');
    var DireccionLinea1 = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_DireccionLinea1');
    var txtColor1 = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_txtColor1');
    var txtColorFondo = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_txtColorFondoo');
    var txtResponsables = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_txtResponsables');
    var txtReferidoPor = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_txtReferidoPor');
    var cbPagoAnual = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_cbPagoAnual');
    var cbUsaCierreCaja = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_cbUsaCierreCaja');
    var cbUsaCardNet = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_cbUsaCardNet');
    var cbUsaPagoEnline = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_cbUsaPagoEnline');
    var cbUsaVisadNet = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_cbUsaVisadNet');
    var cbUsaAzul = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_cbUsaAzul');
    var cbUsaImpresoraFiscal = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_cbUsaImpresoraFiscal');
    var cbUsaFactoring = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_cbUsaFactoring');
    var cbUsaConsulta = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_cbUsaConsulta');
    var cbUsaCentroCosto = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_cbUsaCentroCosto');
    var cbUsaRRHH = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_cbUsaRRHH');
    var cbUsaPrestamo = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_cbUsaPrestamo');
    var txtCorreoElectronicoCobro = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_txtCorreoElectronicoCobro');
    var txtNombreCliente = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_txtNombreCliente');
    var txtDocumento = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_txtDocumento');
    var ddlTipoDocumento = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_ddlTipoDocumento');
    var txtTelefonoCobro1 = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_txtTelefonoCobro1');
    var txtTelefonoCobro2 = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_txtTelefonoCobro2');
    var ddlTipoNCF = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_ddlTipoNCF');
    var luProvincia = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_luProvincia');
    var ddlMunicipio = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_ddlMunicipio');
    var ddlBarrio = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_ddlBarrio');
    var ddlSubBarrio = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_ddlSubBarrio');
    var ddlFechaCierreFiscal = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_ddlFechaCierreFiscal');
    var cbUsaShopify = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_cbUsaShopify');
    var cbUsaWooCommerce = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_cbUsaWooCommerce');
    var luActividadEco = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_luActividadEco')
    var fuLogo = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_fuLogo')

    var hfMontoAnual = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_hfMontoAnual');
    var hfMontoSubTotal = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_hfMontoSubTotal');
    var hfMontoReferido = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_hfMontoReferido');
    var cbusaFacturacionElectronica = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_cbusaFacturacionElectronica');
    var cbUsaCardNetEnLinea = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_cbUsaCardNetEnLinea');
    var cbUsaTermialPOS = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_cbUsaTermialPOS');
    var hfTipoPlanEcf = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_hfTipoPlanEcf');
    var hfTipoPlanReferido = document.getElementById("ContentPH_ucCitrusFormalizarPagoEnLinea_hfTipoPlanReferido");

    var cbUsaPosRestaurante = document.getElementById("ContentPH_ucCitrusFormalizarPagoEnLinea_cbUsaPosRestaurante");
    var cbCantidadDispositivosPOSRestaurante = document.getElementById("ContentPH_ucCitrusFormalizarPagoEnLinea_cbCantidadDispositivosPOSRestaurante");

    cbUsaPosRestaurante.value = compania.UsaPosRestaurante ?? false;
    let cantDispSeleccionado = undefined;
    if (compania.UsaPosRestaurante ?? false) {
      cantDispSeleccionado = CantidadTabletasPOSResturante.find((plan) => plan.value === cantidadDispositivosPosRestaurante)
    }
    cbCantidadDispositivosPOSRestaurante.value = (compania.UsaPosRestaurante && cantDispSeleccionado !== undefined) ? cantDispSeleccionado.name : "No";
    cbUsaTermialPOS.value = compania.UsaModuloAzul || compania.UsaModuloCardNet || compania.UsaModuloVisaNet ? true : false;
    cbUsaCardNetEnLinea.value = compania.UsaCardNetEnLinea ?? false
    cbusaFacturacionElectronica.value = compania.FacturacionElectronica ?? false;
    cbUsaCardNet.value = compania.UsaModuloCardNet ?? false;
    cbUsaVisadNet.value = compania.UsaModuloVisaNet ?? false;
    cbUsaAzul.value = compania.UsaModuloAzul ?? false;
    hfTipoPlanEcf.value = (compania?.FacturacionElectronica ?? false) ? (compania?.TipoPlanEcf ?? "1kT") : ""
    hfMontoAnual.value = montoAnual + pagosUnicos + (pagosUnicos * 0.18);
    hfMontoSubTotal.value = subTotal + pagosUnicos + (pagosUnicos * 0.18);
    hfMontoReferido.value = subTotal + pagosUnicos + (pagosUnicos * 0.18);

    txtNombre.value = compania.NombreComercial;
    txtLicencias.value = compania.licencias ?? 0;
    txtLicenciasCRM.value = compania.licenciasCRM ?? 0;
    txtLicenciasPT.value = 0;

    txtDireccion.value =
      compania?.Direcciones?.length > 0 && compania.Direcciones[0]?.DireccionLinea1
        ? compania.Direcciones[0].DireccionLinea1
        : "";
    txtTelefono.value =
      compania?.Telefonos?.length > 0 && compania.Telefonos[0]?.Telefono
        ? compania.Telefonos[0].Telefono
        : "";
    txtCorreoElectronico.value = compania.Email;
    cbUsaCierreCaja.value = compania.UsaCaja ?? false;
    cbUsaCentroCosto.value = compania.UsaCentro ?? false;
    cbUsaConsulta.value = compania.UsaConsulta ?? false;
    cbUsaFactoring.value = compania.UsaFactoring ?? false;
    cbUsaImpresoraFiscal.value = compania.UsaImpresoraFiscal ?? false;



    cbUsaShopify.value = compania.UsaShopify ?? false;
    cbUsaWooCommerce.value = compania.UsaWooCommerce ?? false;

    cbUsaRRHH.value = compania.UsaNomina ?? false
    cbUsaPrestamo.value = compania.UsaPrestamo ?? false
    cbPagoAnual.value = pagoAnual ?? false;
    ddlTipoDocumento.value = compania.TipoDocumentoCliente;
    txtDocumento.value = compania.DocumentoCliente;
    txtCorreoElectronicoCobro.value = compania.CorreoCobro;
    txtNombreCliente.value = compania.NombreCliente;
    txtResponsables.value = `${compania.NombreCobro} ${compania.ApellidosCobro}`;
    txtTelefonoCobro1.value = compania?.TelefonoCobro[0]?.Telefono;
    txtTelefonoCobro2.value = compania?.TelefonoCobro[1]?.Telefono ?? "";

    txtTelefono.value =
      compania?.Telefonos?.length > 0 && compania.Telefonos[0]?.Telefono
        ? compania.Telefonos[0].Telefono
        : "";
    if (compania?.Direcciones?.length > 0) {
      luProvincia.value = parseInt(compania?.Direcciones[0]?.DireccionProvincia) ?? 0;
      ddlMunicipio.value = compania?.Direcciones[0]?.DireccionMunicipio ?? 0;
      ddlBarrio.value = compania?.Direcciones[0]?.DireccionBarrio ?? 0;
      ddlSubBarrio.value = compania?.Direcciones[0]?.DireccionSubBarrio ?? 0;
    }
    ddlTipoNCF.value = compania?.clienteTipo ?? "C";
    ddlFechaCierreFiscal.value = compania?.cierreFiscal ?? "A";
    luRncCia.value = compania?.RNC ?? "";
    luActividadEco.value = compania.ActividadEconomica ?? null
    txtReferidoPor.value = ReferidoPor ?? null
    txtColor1.value = compania.Color1 ?? "F16101";
    txtCodigo.value = compania.Codigo.trim();
    txtRazon.value = compania?.RazonSocial ?? "";
    hfTipoPlanReferido.value = (EsReferido ?? false) ? `${tipoPlanReferido}` : 'N/A';
  }
  function calculateTotal(pagoAnual, esReferido) {

    let descuentoMultiplier = 1;
    let descuentoAnualMultiplier = pagoAnual ? (esReferido ? 0.8625 : 0.9) : 1;

    var costoLicenciaUnitario = escenario === '4' ? COSTO_LICENCIA_ACADEMICA : COSTO_LICENCIA;

    const costoLicencias = costoLicenciaUnitario * ((compania.licencias ?? 0) + (compania.licenciasCRM ?? 0));
    setTotalLicencia(costoLicencias);

    const costoModulo = COSTO_MODULOS_ADICIONALES;
    const costoModulos = costoModulo * modulosAdicionales.length;
    let costoIntegraciones = costoModulo * (
      (intPanelFirma[0] !== null && intPanelFirma.length > 0 ? 1 : 0) +
      (intLinkPago[0] !== null && intLinkPago.length > 0 ? 1 : 0) +
      (intDgii[0] !== null && intDgii.length > 0 && intDgii[0] !== 1 ? 1 : 0) +
      (intComercioElectronico[0] !== null && intComercioElectronico.length > 0 ? 1 : 0)
    );
    let pagosUnicos = ((intPanelFirma[0] !== null && intPanelFirma.length > 0 ? 4000 : 0) +
      (intDgii[0] !== null && intDgii.length > 0 && intDgii[0] === 1 ? 10000 : 0) +
      (intDgii[0] !== null && intDgii.length > 0 && intDgii[0] === 2 ? 4000 : 0))
    setPagosUnicos(pagosUnicos);
    descuentoMultiplier = pagoAnual && esReferido ? 1 : (esReferido ? 0.75 : 1);
    const planSeleccionado = PLANES_ECF.find((plan) => plan.value === tipoPlan[0])
    costoIntegraciones += (tipoPlan[0] !== null && tipoPlan.length > 0 && compania.FacturacionElectronica ? planSeleccionado.precio : 0)
    const cantDispSeleccionado = CantidadTabletasPOSResturante.find((plan) => plan.value === cantidadDispositivosPosRestaurante)
    costoIntegraciones += (cantidadDispositivosPosRestaurante !== null && compania.UsaPosRestaurante && cantidadDispositivosPosRestaurante > 0 ? cantDispSeleccionado?.precio : 0)
    const subtotal = (costoLicencias ?? 0) + (costoModulos ?? 0) + (costoIntegraciones ?? 0);
    let montoDescuentoPorCantidadLicencias = subtotal * 0.2;
    let descuentoPorLicenciaMultiplier = 0.2;
    if ((compania?.licencias ?? 0) > 20) {
      descuentoMultiplier = !pagoAnual ? (esReferido ? 0.75 : 0.8) : 1;
      descuentoAnualMultiplier = 0.8;
      setDescuentoCantidadLicencias(montoDescuentoPorCantidadLicencias);
    }
    else {
      setDescuentoCantidadLicencias(0);
    }
    if (tipoPlanReferido === 1) {
      // 25% de descuentos primero 3 meses
      const subTotalConDescuento = subtotal * descuentoMultiplier;
      const descuentoAnual = (subTotalConDescuento * descuentoAnualMultiplier) - subTotalConDescuento;

      setTotalModulos(costoModulos);
      setTotalIntegraciones(costoIntegraciones);
      setSubtotal(subTotalConDescuento);
      setMontoAnual(subTotalConDescuento * descuentoAnualMultiplier * 12);
      setDescuentoAnual(descuentoAnual * 12);

      if ((esReferido && !pagoAnual) || (compania?.licencias ?? 0) > 20) {
        setMontoDescuentoReferencia(subtotal - subTotalConDescuento);
      }
      else {
        setMontoDescuentoReferencia(0);
      }
    } else {
      // primer mes gratis
      setSubtotal(0)
      const montoAnual = (subtotal * 12) - subtotal;
      if (esReferido && !pagoAnual) {
        setMontoDescuentoReferencia(subtotal);
      }
      setMontoAnual(montoAnual * 0.9);
      setDescuentoAnual(montoAnual - (montoAnual * 0.9) + subtotal);
      setTotalModulos(costoModulos);
      setTotalIntegraciones(costoIntegraciones);
    }

  }
  const [orientation, setOrientation] = useState('horizontal')
  const [iconRight, setIconRight] = useState('pi pi-arrow-right')
  const [iconLeft, setIconLeft] = useState('pi pi-arrow-left')
  const handleResize = () => {
    if (window.innerWidth <= 1488) {
      setCanvasPosicion('bottom')
      setOrientation('vertical')
      setIconRight('pi pi-arrow-down')
      setIconLeft('pi pi-arrow-up')

    } else {
      setCanvasPosicion('end')
      setOrientation('horizontal')
      setIconRight('pi pi-arrow-right')
      setIconLeft('pi pi-arrow-left')
    }
  };
  useEffect(() => {
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  //File Upload
  const onFileChange = (files) => {
    if (files.length > 0) {
      const file = files[0];
      if (file) {
        if (validarArchivos(file)) {
          var hfLogoNombre = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_hfLogoNombre');
          var hfLogoSize = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_hfLogoSize');
          var hfLogoExtension = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_hfLogoExtension');
          var hfLogoBytes = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_hfLogoBytes');
          const contentType = file.type;
          hfLogoNombre.value = file.name;
          hfLogoExtension.value = contentType.substring(contentType.lastIndexOf('/') + 1);
          hfLogoSize.value = file.size;

          const reader = new FileReader();
          reader.onload = function (e) {
            var bytes = new Uint8Array(e.target.result);
            var binaryString = '';
            for (var i = 0; i < bytes.byteLength; i++) {
              binaryString += String.fromCharCode(bytes[i]);
            }
            var base64String = btoa(binaryString);

            hfLogoBytes.value = base64String;
          };
          reader.readAsArrayBuffer(file);
        }
      }
      setCompania({
        ...compania,
        Files: files,
      });
    }
  };
  const footerContent = () => {
    return (
      <div>
        <Button label="No" icon="pi pi-times" onClick={(e) => {
          e.preventDefault()
          window.location.href = `${window.location.origin}/Public/citrus_formalizar_pago_linea.aspx?Esc=3`
        }} className="p-button-text" />
        <Button label="Si" icon="pi pi-check" onClick={(e) => {
          e.preventDefault()
          window.location.href = `${window.location.origin}/login.aspx?EsFormalizar=true`
        }} autoFocus />
      </div>
    )
  }
  const ptStepperPanel = {
    separator: { style: { display: 'none' } },
  }
  const handleUploadTranferencia = () => {
    var hfBase64 = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_hfBase64');

    if (hfBase64.value && hfBase64.value !== "") {
      var hfPagoLinea = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_hfPagoLinea');
      hfPagoLinea.value = false;
      var btnAceptar = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_btnAceptar');
      var hfTranDes = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_hfTranDes');
      var hfEsRecurrente = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_hfEsRecurrente');
      hfEsRecurrente.value = false;
      hfTranDes.value = transferenciaDescRef.current.value;
      var closeBtn = dialogPagoRef.current.getCloseButton();
      closeBtn.click();
      showLoading();
      btnAceptar.click();
    } else {
      Warning({ messages: ['Debe subir un archivo tipo imagen o pdf.'] })
    }
  };
  const handleUploadRecurrente = () => {
    var hfBase64 = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_hfBase64');
    if (hfBase64.value && hfBase64.value !== "") {
      var hfPagoLinea = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_hfPagoLinea');
      hfPagoLinea.value = false;
      var btnAceptar = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_btnAceptar');
      var hfEsRecurrente = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_hfEsRecurrente');
      hfEsRecurrente.value = true;
      var closeBtn = dialogPagoRef.current.getCloseButton();
      closeBtn.click();
      showLoading();
      btnAceptar.click();
    } else {
      Warning({ messages: ['Debe subir un archivo tipo imagen o pdf.'] })
    }
  };
  async function validarCampos() {
    let messages = [];
    if (compania.RNC) {
      var parsedRNC = parseInt(compania.RNC.trim())
      if (isNaN(parsedRNC)) {
        messages.push("Información de la compañía: Campo RNC o Cédula tiene un formato invalido.")
      }
      if (compania.RNC.length !== 9 && compania.RNC.length !== 11)
        messages.push("Información de la compañía: Campo RNC o Cédula debe contener 9 u 11 caractéres.")
    }

    if (!compania.Codigo || compania.Codigo === "") {
      messages.push("Información de la compañía: Campo Codigo de la compania es requerido.")
    }
    else {
      await buscarCodigoExistencia().then((resp) => {
        if (resp === true && (codigoPrueba !== compania.Codigo)) {
          messages.push("Información de la compañía: Este Codigo de compania ya existe.")
        }
      })
      if (compania.Codigo.length > 15) {
        messages.push("Información de la compañía: Campo Codigo de la compania es muy largo.")
      }
      if (compania.Codigo.length < 3) {
        messages.push("Información de la compañía: Campo Codigo de la compania es muy corto.")
      }
    }

    if (!compania.NombreComercial || compania.NombreComercial === "") {
      messages.push("Información de la compañía: Campo Nombre Comercial es requerido")
    }
    if (!compania.Email || compania.Email === "") {
      messages.push("Información de la compañía: Campo Correo es requerido")
    }

    if (!compania?.Telefonos?.length > 0) {
      messages.push("Información de la compañía: Campo Telefono es requerido")
    }
    else {
      if (!compania?.Telefonos[0]?.Telefono || compania?.Telefonos[0]?.Telefono === "") {
        messages.push("Información de la compañía: Campo Telefono es requerido")
      } else {
        if (!PhoneFormat.isValid(PhoneFormat.formatPhone(compania.Telefonos[0].Telefono))) {
          messages.push("Información de la compañía: Campo Telefono incorrecto")
        }
      }
      if (compania?.Telefonos[1]) {
        if (!PhoneFormat.isValid(PhoneFormat.formatPhone(compania.Telefonos[1].Telefono))) {
          messages.push("Información de la compañía: Campo Telefono incorrecto")
        }
      }
    }

    if ((compania.licencias ?? 0) === 0 && (compania.licenciasCRM ?? 0) === 0) {
      messages.push("Configuracion de cuenta: Los campos de licencias no pueden ser igual a 0")
    }



    if (compania.licenciasCRM > 0 && ((compania.licencias ?? 0) === 0)) {
      if (intPanelFirma[0] !== null && intPanelFirma.length > 0) {
        messages.push("Para seleccionar un panel de firma agregue al menos una licencia ERP")
      }
      if (intLinkPago[0] !== null && intLinkPago.length > 0) {
        messages.push("Para seleccionar link de pago agregue al menos una licencia ERP")
      }
      if (intComercioElectronico[0] !== null && intComercioElectronico.length > 0) {
        messages.push("Para seleccionar un comercio electronico agregue al menos una licencia ERP")
      }
      if (intDgii[0] !== null && intDgii.length > 0) {
        messages.push("Para seleccionar Facturacion Electronica o Impresora Fiscal agregue al menos una licencia ERP")
      }
      if (modulosAdicionales[0] !== null && modulosAdicionales.length > 0) {
        messages.push("Para seleccionar modulos adicionales agregue al menos una licencia ERP")
      }
      if (otrasConfiguraciones[0] !== null && otrasConfiguraciones.length > 0) {
        messages.push("Para seleccionar Cierre de Caja/Centro de Costos agregue al menos una licencia ERP")
      }
    }
    if (!compania.DocumentoCliente || compania.DocumentoCliente === "") {
      messages.push("Información para facturar el servicio: Campo Documento es requerido. Documento sobre el cual se hará la factura de cobro.")
    }
    if (!compania.NombreCliente || compania.NombreCliente === "") {
      messages.push("Información para facturar el servicio: Campo Nombre es requerido. Nombre del Cliente que saldrá en la factura.")
    }
    if (!compania.NombreCobro || compania.NombreCobro === "") {
      messages.push("Información para facturar el servicio: Campo Nombre de la Persona Responsable es requerido. Persona de contacto.")
    }

    if (!compania?.TelefonoCobro?.length > 0) {
      messages.push("Información para facturar el servicio: Campo Telefono es requerido. Teléfono de la persona de contacto.")
    }
    else {
      if (!compania.TelefonoCobro[0].Telefono || compania?.TelefonoCobro[0]?.Telefono === "") {
        messages.push("Información para facturar el servicio: Campo Telefono es requerido. Teléfono de la persona de contacto.")
      } else {
        if (!PhoneFormat.isValid(PhoneFormat.formatPhone(compania.TelefonoCobro[0].Telefono))) {
          messages.push("Información para facturar el servicio: Campo Telefono incorrecto")
        }
      }
    }
    if (!compania.CorreoCobro || compania.CorreoCobro === "") {
      messages.push("Información para facturar el servicio: Campo Correo es requerido. Correo Electrónico al cual se dirigirá la factura de cobro.")
    }

    if (messages.length > 0) {
      Warning({ messages: messages });
    }
    return messages.length === 0;
  }
  function validarArchivos(file) {
    let messages = [];
    if (!file) {
      messages.push("Debe subir un archivo tipo imagen o pdf.")
    } else if (!file.name.endsWith('.pdf')
      && !file.name.endsWith('.jpeg')
      && !file.name.endsWith('.jpg')
      && !file.name.endsWith('.png')) {
      messages.push("Debe incluir una imagen o documento de la autorización de pago. Formatos aceptados: [.pdf, .jpg, .jpeg, .png].")
    }
    if (messages.length > 0) {
      if (fileUploadRefTransferencia.current) {
        fileUploadRefTransferencia.current.clear();
      }
      if (fileUploadRefRecurrente.current) {
        fileUploadRefRecurrente.current.clear();
      }

      Warning({ messages: messages });
    }
    return messages.length === 0;
  }

  function uint8ArrayToBase64(uint8Array) {
    let binaryArray = [];
    for (let i = 0; i < uint8Array.length; i++) {
      binaryArray.push(String.fromCharCode(uint8Array[i]));
    }
    return btoa(binaryArray.join(''));
  }

  const customBase64Uploader = async (event, esRecurrente = false) => {
    const file = event[0];

    if (file) {
      if (validarArchivos(file)) {
        const reader = new FileReader();
        reader.onload = function (e) {
          var hfBase64 = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_hfBase64');
          var hfAceptar = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_hfAceptar');
          var hfCT = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_hfCT');
          var hfFileType = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_hfFileType');
          hfFileType.value = file.name.substring(file.name.lastIndexOf('.') + 1)
          if (file.name.endsWith('.pdf')) {
            hfCT.value = 'pdf';
          } else {
            hfCT.value = 'img'
          }
          hfAceptar.value = 1;

          if (!e.target.result) {
            Warning({ message: 'Error al cargar el archivo. Borre el archivo e intentelo nuevamente' })
            return;
          }
          let bytes = new Uint8Array(e.target.result);
          let base64String = uint8ArrayToBase64(bytes);
          hfBase64.value = base64String;
        };
        reader.readAsArrayBuffer(file);
      }
    }
  };
  const dialogPagoRef = useRef(null)
  const transferenciaDescRef = useRef(null)
  const pagoTransferenciaBody = () => {
    return (
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <h3>Cuenta Bancaria</h3>
        <p className='bootstrapiso' style={{ marginTop: '0' }}>
          <span className='font-weight-bold'>Banco</span>: Banco Popular Dominicano
          <br />
          <span className='font-weight-bold'>Tipo</span>: Cuenta Corriente
          <br />
          <span className='font-weight-bold'>Número</span>: 769921859
          <br />
          <span className='font-weight-bold'>Propietario</span>: Citrus Technology Group SRL
          <br />
          <span className='font-weight-bold'>RNC</span>: 130815348
          <br />
        </p>
        <h3>Comprobante</h3>
        <InputContainer label="Seleccione un archivo">
          <DropZone
            key={dropZoneKey}
            styles={{ marginLeft: "0px" }}
            label="Dé click o arrastre la Imagen para continuar"
            multiple={false}
            updateFilesCb={customBase64Uploader}
            type="image-pdf"
            files={[]}
            useVideo={false}
          />
        </InputContainer>
        <h3>Descripcion</h3>
        <InputTextarea ref={transferenciaDescRef} rows={5} cols={30} />
        <div className='bootstrapiso'>
          <div className="d-flex justify-content-center mt-3">
            <Button label='Enviar' onClick={handleUploadTranferencia} />
          </div>
        </div>
      </div>
    )
  }
  const inputRef = useRef(null);
  const fechaRef = useRef(null)
  const cvvRef = useRef(null)
  const nombreTarjetaRef = useRef(null)
  const handleCardNumberChange = () => {
    let cardNumber = inputRef.current.value.replace(/\D/g, '').substring(0, 19);
    let formattedNumber;

    // Check if the card is an Amex card
    const isAmex = /^3[47]/.test(cardNumber);

    if (isAmex) {
      formattedNumber = cardNumber.replace(/(\d{4})(\d{6})(\d{5})/, '$1 $2 $3');
    } else {
      formattedNumber = cardNumber.replace(/(\d{4})(?=\d)/g, '$1 ');
    }

    inputRef.current.value = formattedNumber;
  };
  const handleExpDateChange = () => {
    let expDate = fechaRef.current.value.replace(/\D/g, '').substring(0, 4);
    let formattedExpDate = expDate.replace(/(\d{2})(?=\d)/g, '$1/');
    fechaRef.current.value = formattedExpDate;
  };
  const handleCvvChange = () => {
    let cvv = cvvRef.current.value.replace(/\D/g, '').substring(0, 4);
    cvvRef.current.value = cvv;
  };
  const pagoTarjetaBody = () => {
    return (
      <div className='bootstrapiso'>
        <Card.Header style={{ backgroundColor: '#fff', borderBottom: 'unset' }}>
          <img style={{ maxHeight: '50px', position: 'absolute', right: '0', marginRight: '45px', paddingBottom: '20px' }} src="../../../../img/tarjetas-pq.png" />
        </Card.Header>
        <Card.Body style={{ height: 'auto' }}>
          <Row style={{ marginBottom: '1rem' }}>
            <Col sm={8} md={8} className="pt-4">
              <Row style={{ marginBottom: '1rem' }}>
                <Col className="form-input" style={{ paddingRight: '0px', maxWidth: '55%', flex: '0 0 55%' }}>
                  <Form.Group className="form-outline" data-mdb-input-init>
                    <Form.Label htmlFor="cc-number">Número de tarjeta</Form.Label>
                    <Form.Control
                      type="tel" maxLength="19"
                      id="txtNumero"
                      name="cc-number"
                      autoComplete="cc-number"
                      placeholder="•••• •••• •••• ••••"
                      required
                      className="form-control cc-number"
                      ref={inputRef}
                      onChange={handleCardNumberChange}
                    />
                  </Form.Group>
                </Col>
                <Col style={{ paddingRight: '7px', paddingLeft: '7px', maxWidth: '25%', flex: '0 0 22%' }}>
                  <Form.Group className="form-outline" data-mdb-input-init>
                    <Form.Label htmlFor="cc-exp">Exp.</Form.Label>
                    <Form.Control
                      type="tel" maxLength="5"
                      id="txtFecha"
                      name="cc-exp"
                      autoComplete="cc-exp"
                      placeholder="•• / ••"
                      required
                      className="form-control cc-exp"
                      ref={fechaRef}
                      onChange={handleExpDateChange}
                    />
                  </Form.Group>
                </Col>
                <Col style={{ paddingLeft: '0', maxWidth: '25%', flex: '0 0 22%' }}>
                  <Form.Group className="form-outline" data-mdb-input-init>
                    <Form.Label htmlFor="cc-cvc">Cvv</Form.Label>
                    <Form.Control
                      type="tel" maxLength="4"
                      id="txtCVV"
                      name="cc-cvc"
                      autoComplete="off"
                      placeholder="•••"
                      required
                      className="form-control cc-cvc"
                      ref={cvvRef}
                      onChange={handleCvvChange}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Form.Group className="form-outline" data-mdb-input-init>
                <Form.Label htmlFor="numeric">Nombre del titular</Form.Label>
                <Form.Control
                  type="text"
                  id="txtNombre"
                  name="cc-name"
                  autoComplete="off"
                  required
                  className="input-lg form-control"
                  ref={nombreTarjetaRef}

                />
              </Form.Group>
            </Col>
            <Col sm={4} md={4} className="pt-4">
              <Row style={{ marginBottom: '1rem' }}>
                <Col>
                  <Form.Group className="form-outline" data-mdb-input-init>
                    <Form.Label className="text-right" htmlFor="txtFacturaMontoSinImpuesto">Monto</Form.Label>
                    <Form.Control
                      type="text"
                      id="txtFacturaMontoSinImpuesto"
                      readOnly
                      className="input-sm form-control text-right"
                      value={pagoAnual ? Citrus.Convert.toCurrencyNoSimbolo(montoAnual + pagosUnicos) : Citrus.Convert.toCurrencyNoSimbolo(subTotal + pagosUnicos)}
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className="form-outline" data-mdb-input-init>
                    <Form.Label className="text-right" htmlFor="txtFacturaImpuesto">Impuesto</Form.Label>
                    <Form.Control
                      type="text"
                      id="txtFacturaImpuesto"
                      readOnly
                      className="input-sm form-control text-right"
                      value={Citrus.Convert.toCurrencyNoSimbolo(pagosUnicos * 0.18)}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Form.Group className="form-outline" data-mdb-input-init>
                <Form.Label className="text-right" htmlFor="txtFacturaTotal">Total</Form.Label>
                <Form.Control
                  type="text"
                  id="txtFacturaTotal"
                  readOnly
                  className="input-sm form-control text-right"
                  value={pagoAnual ? Citrus.Convert.toCurrencyNoSimbolo(montoAnual + pagosUnicos + (pagosUnicos * 0.18)) : Citrus.Convert.toCurrencyNoSimbolo(subTotal + pagosUnicos + + (pagosUnicos * 0.18))}
                />
              </Form.Group>
            </Col>
          </Row>
          <Form.Group>
            <Button type="button" onClick={(e) => pagoTarjeta(e)} className="btn btn-success btn-lg form-control">Procesar</Button>
          </Form.Group>
          <input id="cc-type" name="cc-type" type="hidden" value="" />
        </Card.Body>
      </div>
    )
  }
  function validarTarjeta() {
    let messages = []
    let expDate = fechaRef.current.value;
    let today = new Date();
    let enteredMonth = parseInt(expDate.substring(0, 2), 10);
    let enteredYear = parseInt(expDate.substring(3, 5), 10);
    let enteredDate = new Date('20' + enteredYear, enteredMonth - 1, 1);

    if (!(enteredMonth <= 12)) {
      messages.push("Fecha de expiracion incorrecta: Mes incorrecto ")
    }
    if (!(enteredDate > today)) {
      messages.push("Fecha de expiracion incorrecta: La tarjeta esta vencida")
    }
    if (!inputRef.current.value) {
      messages.push("Numero de tarjeta es requerido")
    }
    if (!cvvRef.current.value) {
      messages.push("CVV es requerido")
    }
    if (cvvRef.current.value.length < 3) {
      messages.push("CVV es incorrecto")
    }
    if (!nombreTarjetaRef.current.value) {
      messages.push("Nombre del titular es requerido")
    }
    if (messages.length > 0) {
      Warning({ messages: messages })
    }
    return messages.length === 0;
  }
  const pagoTarjeta = (e) => {
    e.preventDefault();
    var closeBtn = dialogPagoRef.current.getCloseButton();
    closeBtn.click();
    showLoading();
    if (escenario === '4') {
      var txtLicencias = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_txtLicencias');
      var txtLicenciasCRM = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_txtLicenciasCRM');
      var txtLicenciasPT = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_txtLicenciasPT');
      var cbUsaCierreCaja = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_cbUsaCierreCaja');
      var cbUsaCentroCosto = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_cbUsaCentroCosto');
      var cbUsaRRHH = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_cbUsaRRHH');
      var luRncCia = document.getElementById("ContentPH_ucCitrusFormalizarPagoEnLinea_luRncCia");
      var txtNombre = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_txtNombre');
      var txtDireccion = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_txtDireccion');
      var txtCorreoElectronico = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_txtCorreoElectronico');
      var txtTelefono = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_txtTelefono');
      var hfMontoSubTotal = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_hfMontoSubTotal');
      var txtCodigo = document.getElementById("ContentPH_ucCitrusFormalizarPagoEnLinea_txtCodigo");

      txtCodigo.value = compania.Codigo;
      txtLicencias.value = compania.licencias ?? 0;
      txtLicenciasCRM.value = compania.licenciasCRM ?? 0;
      txtLicenciasPT.value = compania.licenciasPT ?? 0;
      cbUsaCierreCaja.value = compania.UsaCaja ?? false;
      cbUsaCentroCosto.value = compania.UsaCentro ?? false;
      cbUsaRRHH.value = compania.UsaNomina ?? false;
      cbUsaPrestamo.value = compania.UsaPrestamo ?? false;
      luRncCia.value = compania.RNC;
      txtNombre.value = compania.NombreComercial;
      txtCorreoElectronico.value = compania.Email;
      hfMontoSubTotal.value = subTotal;
      txtTelefono.value = compania?.Telefonos[0]?.Telefono ?? ''
      txtDireccion.value = compania?.Direcciones[0].DireccionLinea1 ?? ''
    }
    if (validarTarjeta()) {
      const consultaId = Math.random();
      consultaActualId.current = consultaId;
      const Origen = escenario === 4 ? 'L' : 'C'
      const url = PROCESAR_PAGO_TC;
      let montoTotal = pagoAnual ? montoAnual : subTotal;
      montoTotal += pagosUnicos + (pagosUnicos * 0.18)
      const impuestos = pagosUnicos * 0.18;
      let messages = [];
      try {
        buscar(url, { request: { Origen, numero: inputRef.current.value, cvv: cvvRef.current.value, fecha: fechaRef.current.value, montoTotal, impuestos, nombreCompania: compania.NombreComercial } }).then((data) => {
          if (consultaId === consultaActualId.current) {
            if (data) {
              if (data.ErrorMessages.length > 0) {
                hideLoading();
                setPagoModalVisible(true)
                Error({ messages: data.ErrorMessages })
              } else if (data.WarningMessages.length > 0) {
                hideLoading();
                setPagoModalVisible(true)
                Warning({ messages: data.WarningMessages })
              } else {
                Message({ messages: data.Messages })
                var hfPagoLinea = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_hfPagoLinea');
                hfPagoLinea.value = true;
                var hfBase64 = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_hfBase64');
                hfBase64.value = ""
                var btnAceptar = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_btnAceptar');
                btnAceptar.value = 1;
                btnAceptar.click();
              }
            }
          }
        }).catch((err) => {
          console.log(err);
        })
      } catch (e) {
        console.log(e)
      }
    }
    else {
      hideLoading();
      setPagoModalVisible(true)
    }
  }
  const pagoRecurrenteBody = () => {
    return (
      <div className='bootstrapiso'>
        <h3>Formulario</h3>
        <InputContainer label="Seleccione un archivo">
          <DropZone
            key={dropZoneKey}
            styles={{ marginLeft: "0px" }}
            label="Dé click o arrastre la Imagen para continuar"
            multiple={false}
            updateFilesCb={customBase64Uploader}
            type="pdf"
            files={[]}
            useVideo={false}
          />
        </InputContainer>
        <a href='../../../../templates/Formulario - Autorización Cargo Tarjeta Credito.pdf' target='_blank'>
          Descargar formulario de Pago Recurrente
        </a>
        <div className="d-flex justify-content-center mt-3">
          <Button label='Enviar' onClick={handleUploadRecurrente} />
        </div>
      </div>

    )
  }


  function ContinuarFomalizacion(resp) {
    if (resp) {
      setWindowVariables()
      if (tipoPlanReferido !== 2) {
        switch (tipoPago) {
            case 0:
            setHeader('Pago Directo con Tarjeta de Credito')
            setBody(pagoTarjetaBody())
            setPagoModalVisible(true)
            break
          case 1:
            setHeader('Envio de Comprobante de Pago')
            setBody(pagoTransferenciaBody)
            setPagoModalVisible(true)
            break;
          case 2:
            setHeader("Descarga y llena el formulario");
            setBody(pagoRecurrenteBody)
            setPagoModalVisible(true)
            break;
          default:
            Warning({ messages: ['Seleccione uno de los tipos de pago'] })
        }
      } else {
        var hfPagoLinea = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_hfPagoLinea');
        hfPagoLinea.value = false;
        var btnAceptar = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_btnAceptar');
        var hfEsRecurrente = document.getElementById('ContentPH_ucCitrusFormalizarPagoEnLinea_hfEsRecurrente');
        hfEsRecurrente.value = false;
        showLoading();
        btnAceptar.click();
      }
    }
  }

  function handleTipoDePago(e) {
    e.preventDefault()
    validarCampos().then((resp) => {

      if (compania.Codigo.trim() === codigoPrueba.trim()) {
        Confirm({
          type: Types.TYPE_DEFAULT,
          title: `Código de Compañía`,
          textBody: `Está formalizando estableciendo el Código de Compañía (para sus credenciales de acceso) el mismo código de su cuenta de prueba ${codigoPrueba}.\n Prefiere usted establecer un código que represente más el nombre de su empresa?`,
          onConfirm: () => { ContinuarFomalizacion(resp) },
          onCancel: () => {
            stepperRef.current.setActiveStep(0)
            setTimeout(() => { codigoInputRef.current.focus() }, 1000)
          },
          confirmBtnText: "Si",
          cancelBtnText: "No",
        });
      } else {
        ContinuarFomalizacion(resp)
      }
    })
  }
  async function buscarCodigoExistencia() {
    const consultaId = Math.random();
    consultaActualId.current = consultaId;
    let existe = false;
    const url = BUSCAR_CODIGO_EXISTENCIA;
    try {
      await buscar(url, { codigo: compania.Codigo, companiaId: (compania?.Id || 0) }).then((data) => {
        if (consultaId === consultaActualId.current) {
          if (data) {
            existe = data.existe;
          }
        }
      }).catch((err) => {
        existe = false;
      })
    } catch (e) {
      existe = false;
    }
    return existe;
  }
  const ptSelectButton =
  {
    button: { style: { border: "1px solid #ff7b00", color: "#ff7b00" } }
  }
  const ptButton = { root: { style: { borderRadius: '50%' } } }
  const [refValida, setRefValida] = useState(false);
  useEffect(() => {
    if (refValida) {
      setTipoPlanReferido(2)
    } else {
      setTipoPlanReferido(1)
    }
  }, [refValida]);
  useEffect(() => {
    if (EsReferido) {
      const consultaId = Math.random();
      consultaActualId.current = consultaId;
      const url = VALIDAR_REFERENCIA_CLIENTE
      try {
        buscar(url, { codigoCompania: window.ReferidoPorId, documento: compania.DocumentoCliente }).then((data) => {
          if (consultaId === consultaActualId.current) {
            if (data) {
              setRefValida(data.existe);
            }
          }
        }).catch((err) => {
          setRefValida(false);
        })
      } catch (e) {
        setRefValida(false);
      }
    }
  }, [compania.DocumentoCliente]);

  function onHidePagoModal() {
    setPagoModalVisible(false)
  }

  const page = () => {
    return (
      <div className="bootstrapiso" style={{ backgroundColor: '#e9e9e9', marginTop: '-20px' }}>
        <Container className="py-5 mx-aut" style={{ maxWidth: '1580px' }}>
          <Dialog header="¿Tienes una cuenta de prueba de Citrus ERP?" visible={visible} style={{ width: '30vw' }}
            footer={footerContent} onHide={() => setVisible(false)} breakpoints={{ '1280': '50vw', '960px': '75vw', '641px': '400px', '400px': '300px' }}
            pt={{
              closeButton: { style: { display: 'none' } },
              content: { style: { display: 'none' } },
              footer: { style: { display: 'flex', justifyContent: 'center' } }
            }}>
          </Dialog>
          <Dialog ref={dialogPagoRef} header={header} visible={pagoModalVisible} style={{ width: '50vw' }} breakpoints={{ '1280': '50vw', '960px': '75vw', '641px': '450px', '400px': '350px' }} onHide={onHidePagoModal}
            pt={{
              root: { style: { backgroundColor: '#fff' } },
              header: { style: { backgroundColor: '#F16101', color: '#fff', borderRadius: '6px', margin: '10px', padding: '10px' } },
              closeButtonIcon: { style: { color: '#fff' } }
            }}
          >
            {body}
          </Dialog>
          <Form
            action=""
            className="form-horizontal"
            id="TypeValidation"
            method=""
          >
            <div className="card h-100 shadow-sm" style={{ borderRadius: '10px' }}>
              <div className='d-flex justify-content-center'>
                <img
                  style={{ objectFit: "contain" }}
                  alt="logo"
                  src="../../../../img/logo_citrus.png"
                  height=""
                  width="275px"
                />
              </div>
              {escenario === '4' ? (
                <Stepper pt={{
                  nav: { style: { justifyContent: 'space-evenly' } },
                  panelContainer: { style: { borderRadius: '10px' } },
                  stepperpanel: { style: { flex: 'unset' } }
                }} orientation={orientation} ref={stepperRef}>
                  <StepperPanel pt={ptStepperPanel} header="Licencias">
                    <div className="bootstrapiso">
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        <div
                          className="card mb-4 shadow-sm mt-3"
                          style={{ minWidth: "25%", }}
                        >
                          <div className="card-header">
                            <h4 className="my-0 font-weight-normal">Subtotal</h4>
                          </div>
                          <div className="card-body d-flex flex-column">
                            <h1 className="card-title pricing-card-title" style={{ fontSize: '1.5rem' }}>
                              {pagoAnual
                                ? `RD$${Citrus.Convert.toCurrencyNoSimbolo(
                                  montoAnual
                                )}`
                                : `RD$${Citrus.Convert.toCurrencyNoSimbolo(
                                  subTotal
                                )}`}
                              <small  >
                                {pagoAnual
                                  ? ` / anual`
                                  : " / mes"}
                              </small>
                            </h1>
                            <span className='text-muted' style={{ fontSize: '20px' }}>
                              {pagoAnual ? (
                                `Ahorro total RD$${Citrus.Convert.toCurrencyNoSimbolo(
                                  Math.abs(descuentoAnual) ?? 0
                                )}`
                              ) : (
                                EsReferido && (
                                  `Ahorro total RD$${Citrus.Convert.toCurrencyNoSimbolo(
                                    Math.abs(montDescuentoReferencia) ?? 0
                                  )}`
                                )
                              )}
                            </span>
                          </div>
                        </div>
                      </div>
                      <EditSection mb='2' title="Indique la cantidad de licencias que desea:">
                        <Row>
                          <Col>
                            <div>
                              <label
                                style={{ display: "block" }}
                                htmlFor="licencias-erp"
                              >
                                Citrus ERP
                              </label>
                              <InputNumber
                                pt={{
                                  incrementButton: { style: { background: "#fcbf494f", color: "#ff7b00", WebkitBorderTopRightRadius: '6px' } },
                                  decrementButton: { style: { background: "#fcbf494f", color: "#ff7b00", WebkitBorderBottomRightRadius: '6px' } },
                                }}
                                inputId="licencias-erp"
                                value={compania.licencias ?? 0}
                                onValueChange={(e) => {
                                  e.preventDefault();
                                  setCompania({
                                    ...compania,
                                      licencias: e.value,
                                  })
                                }}
                                mode="decimal"
                                showButtons
                                min={0}
                                max={100}
                              />
                            </div>
                          </Col>
                          <Col >
                            <div>
                              <label
                                style={{ display: "block" }}
                                htmlFor="licencias-crm"
                              >
                                Citrus CRM
                              </label>
                              <InputNumber
                                pt={{
                                  incrementButton: { style: { background: "#fcbf494f", color: "#ff7b00", WebkitBorderTopRightRadius: '6px' } },
                                  decrementButton: { style: { background: "#fcbf494f", color: "#ff7b00", WebkitBorderBottomRightRadius: '6px' } },
                                }}
                                inputId="licencias-crm"
                                value={compania.licenciasCRM ?? 0}
                                onValueChange={(e) => {
                                  e.preventDefault();
                                  setCompania({
                                    ...compania,
                                    licenciasCRM: e.value
                                  })
                                }}
                                mode="decimal"
                                showButtons
                                min={0}
                                max={100}
                              />
                            </div>
                          </Col>
                        </Row>
                      </EditSection>
                      <EditSection mb='2' style={{ marginTop: "2rem" }} title="Configuraciones Opcionales libre de costo">
                        <Row>
                          <Col>
                            <SelectButton
                              pt={ptSelectButton}
                              className="d-flex"
                              value={configOpcionalesAcadmico}
                              onChange={(e) => {
                                setCompania({
                                  ...compania,
                                  UsaNomina: e.value.some((item) => item === 1),
                                  UsaCaja: e.value.some((item) => item === 2),
                                  UsaCentro: e.value.some((item) => item === 3)
                                })
                                setConfigOpcionalesAcademico(e.value)
                              }}
                              options={CONFIGURACION_OPCIONALES_FORMALIZACION_ACADEMICA}
                              optionLabel="name"
                              multiple
                            />
                          </Col>
                        </Row>
                      </EditSection>
                    </div>
                    <div className="d-flex pt-4 justify-content-end">
                      <Button pt={ptButton} rounded outlined icon={iconRight} iconPos="right" onClick={(e) => {
                        e.preventDefault()
                        stepperRef.current.nextCallback()
                      }} />
                    </div>
                  </StepperPanel>
                  <StepperPanel pt={ptStepperPanel} header="Pago">
                    <div style={{ marginBottom: '10px' }} className="flex pt-4 justify-content-start">
                      <EditSection mb='2' title="Detalles del servicio adquirido">
                        <SectionRow alignItems >
                          <div className="list-group" style={{ marginBottom: '15px' }}>
                            {compania.licencias > 0 && (
                              <a
                                href="#"
                                className="list-group-item list-group-item-action"
                              >
                                <div className="d-flex w-100 justify-content-between">
                                  <h5 className="mb-1" style={{ width: '70%', display: 'flex', flexDirection: 'column' }}>
                                    x{compania.licencias} Licencias ERP
                                  </h5>
                                  <small>RD$ {Citrus.Convert.toCurrencyNoSimbolo(COSTO_LICENCIA_ACADEMICA * compania.licencias)}</small>
                                </div>
                              </a>
                            )}
                            {compania.licenciasCRM > 0 && (
                              <a
                                href="#"
                                className="list-group-item list-group-item-action"
                              >
                                <div className="d-flex w-100 justify-content-between">
                                  <h5 className="mb-1" style={{ width: '70%', display: 'flex', flexDirection: 'column' }}>
                                    x{compania.licenciasCRM} Licencias CRM
                                  </h5>
                                  <small>RD$ {Citrus.Convert.toCurrencyNoSimbolo(COSTO_LICENCIA_ACADEMICA * compania.licenciasCRM)}</small>
                                </div>
                              </a>
                            )}
                            {configOpcionalesAcadmico.map((modulo) => {
                              const selectedModulo = CONFIGURACION_OPCIONALES_FORMALIZACION_ACADEMICA.find(
                                (mod) => mod.value === modulo
                              );
                              if (selectedModulo) {
                                return (
                                  <a
                                    href="#"
                                    className="list-group-item list-group-item-action"
                                    key={selectedModulo.value}
                                  >
                                    <div className="d-flex w-100 justify-content-between">
                                      <h5 className="mb-1" style={{ width: '70%', display: 'flex', flexDirection: 'column' }}>
                                        Modulo {selectedModulo.name}
                                      </h5>
                                      <small>RD$ {Citrus.Convert.toCurrencyNoSimbolo(0)}</small>
                                    </div>
                                  </a>
                                );
                              } else {
                                return null;
                              }
                            })}
                          </div>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                            }}
                          >
                            <div
                              className="card mb-4 shadow-sm"
                              style={{ width: '100%' }}
                            >
                              <div className="card-header">
                                <h4 className="my-0 font-weight-normal">
                                  Monto a pagar
                                </h4>
                              </div>
                              <div className="card-body">
                                <div className='d-flex justify-content-between'>
                                  <h1 className="card-title pricing-card-title" style={{ fontSize: '1.5rem' }}>
                                    Subtotal:
                                  </h1>
                                  <h1 className="card-title pricing-card-title" style={{ fontSize: '1.5rem' }}>
                                    {pagoAnual
                                      ? ` RD$${Citrus.Convert.toCurrencyNoSimbolo(
                                        (montoAnual + pagosUnicos + Math.abs(descuentoAnual)) ?? 0
                                      )}`
                                      : ` RD$${Citrus.Convert.toCurrencyNoSimbolo(
                                        (subTotal + pagosUnicos + Math.abs(montDescuentoReferencia)) ?? 0
                                      )}`}
                                  </h1>
                                </div>
                                <div className='d-flex justify-content-between'>
                                  <h1 className="card-title pricing-card-title" style={{ fontSize: '1.5rem' }}>
                                    Descuento:
                                  </h1>
                                  <h1 className="card-title pricing-card-title" style={{ fontSize: '1.5rem' }}>
                                    {pagoAnual ? (
                                      `RD$${Citrus.Convert.toCurrencyNoSimbolo(
                                        Math.abs(descuentoAnual) ?? 0
                                      )}`
                                    ) : (
                                      EsReferido ? (
                                        `RD$${Citrus.Convert.toCurrencyNoSimbolo(
                                          Math.abs(montDescuentoReferencia ?? 0)
                                        )}`
                                      ) : (
                                        `RD$${Citrus.Convert.toCurrencyNoSimbolo(
                                          0
                                        )}`
                                      )
                                    )}
                                  </h1>
                                </div>
                                <div className='d-flex justify-content-between'>
                                  <h1 className="card-title pricing-card-title" style={{ fontSize: '1.5rem' }}>
                                    Impuestos:
                                  </h1>
                                  <h1 className="card-title pricing-card-title" style={{ fontSize: '1.5rem' }}>
                                    {pagoAnual
                                      ? ` RD$${Citrus.Convert.toCurrencyNoSimbolo(
                                        (pagosUnicos * 0.18)
                                      )}`
                                      : ` RD$${Citrus.Convert.toCurrencyNoSimbolo(
                                        (pagosUnicos * 0.18)
                                      )}`}
                                  </h1>
                                </div>
                                <div className='d-flex justify-content-between'>
                                  <h1 className="card-title pricing-card-title" style={{ fontSize: '1.5rem' }}>
                                    Total:
                                  </h1>
                                  <h1 className="card-title pricing-card-title" style={{ fontSize: '1.5rem' }}>
                                    {pagoAnual
                                      ? ` RD$${Citrus.Convert.toCurrencyNoSimbolo(
                                        montoAnual + pagosUnicos + (pagosUnicos * 0.18)
                                      )}`
                                      : ` RD$${Citrus.Convert.toCurrencyNoSimbolo(
                                        subTotal + pagosUnicos + (pagosUnicos * 0.18)
                                      )}`}
                                  </h1>
                                </div>
                              </div>
                            </div>
                          </div>
                        </SectionRow>
                      </EditSection>
                      <div className="d-flex justify-content-center mt-3" style={{ marginBottom: '10px' }} >
                        <Button pt={{ root: { style: { borderRadius: '6px' } } }} label='Aceptar' style={{ width: orientation === 'vertical' ? '-webkit-fill-available' : '200px', fontSize: 'larger' }} onClick={(e) => {
                          e.preventDefault()
                          let messages = [];
                          if ((compania.licencias ?? 0) === 0 && (compania.licenciasCRM ?? 0) === 0) {
                            messages.push("Licencia: Los campos de licencias no pueden ser igual a 0")
                          } else {
                            setHeader('Pago Directo con Tarjeta de Credito')
                            setBody(pagoTarjetaBody())
                            setPagoModalVisible(true)
                          }
                          if (messages.length > 0) {
                            Warning({ messages: messages });
                            setPagoModalVisible(false)
                          }
                        }} />
                      </div>
                    </div>
                    <Button pt={ptButton} rounded outlined severity="secondary" icon={iconLeft} onClick={(e) => {
                      e.preventDefault()
                      stepperRef.current.prevCallback()
                    }} />
                  </StepperPanel>
                </Stepper>

              ) : (
                <Stepper pt={{
                  panelContainer: { style: { borderRadius: '10px' } },
                }} orientation={orientation} ref={stepperRef}>
                  <StepperPanel pt={ptStepperPanel} header="Información de la compañía">
                    <EditSection title="Información General" mb='2'>
                      <SectionRow>
                        <InputContainer label="Documento">
                          <RncLookup
                            placement={canvasPosicion}
                            isInput={false}
                            initialValue={{ value: compania?.RNC }}
                            onChange={(e) =>
                              setCompania({
                                ...compania,
                                RNC: e.value,
                                RazonSocial: e.nombre || compania.RazonSocial
                              })
                            }
                          />
                        </InputContainer>
                        <InputContainer tooltipPlacement='left'
                          label="Código"
                          tooltip
                          message={`Código de compañía es el nombre único que representará su empresa en las credenciales de acceso al sistema. 
                                            A continuación sugerencias de código según el nombre de su compañía, para estos ejemplos tomaremos el nombre \"Citrus Technology Group\": 
                                            * ctg123 
                                            * citrustg
                                            * citechgroup`}>
                          <Form.Control
                            style={{ borderLeft: "3px solid red" }}
                            required
                            onChange={(e) => {
                              FormHelper.handleChange(e, setCompania)
                            }
                            }
                            ref={codigoInputRef}
                            name="Codigo"
                            type="text"
                            value={compania?.Codigo}
                            onKeyPress={(e) => {
                              if (!/^[a-zA-Z0-9]*$/.test(e.key)) {
                                e.preventDefault();
                              }
                            }}
                          />
                          <Form.Text className="text-danger" id="validationMsg" muted>
                            Código de la compañía tiene que tener mínimo 3 y máximo 15 caracteres.
                          </Form.Text>
                          <Form.Text className="text-danger" id="validationMsg" muted>
                            Ej: servicio123, serviventas
                          </Form.Text>
                        </InputContainer>

                      </SectionRow>
                      <SectionRow>
                        <ControlledInput
                          label="Razón Social"
                          name="RazonSocial"
                          type="text"
                          value={compania?.RazonSocial || ""}
                          setState={setCompania}
                          style={{ paddingRight: '25px' }}
                        />
                        <ControlledInput
                          required
                          label="Nombre Comercial"
                          name="NombreComercial"
                          type="text"
                          setState={setCompania}
                          value={compania?.NombreComercial || ""}
                        />
                      </SectionRow>
                      <SectionRow>
                        <InputContainer label="Cierre Fiscal">
                          <Select
                            className="basic-single"
                            classNamePrefix="select"
                            name="Cierre Fiscal"
                            onChange={(e) => {
                              setCompania({
                                ...compania,
                                cierreFiscal: e.value,
                              })
                            }
                            }
                            options={FECHA_CIERRE_FISCAL}
                            value={
                              esNuevo && !compania?.cierreFiscal
                                ? FECHA_CIERRE_FISCAL.filter(function (option) {
                                  return option.value === "A";
                                })
                                : FECHA_CIERRE_FISCAL.filter(function (option) {
                                  return option.value === (compania?.cierreFiscal || "A");
                                })
                            }
                          />
                        </InputContainer>
                      </SectionRow>
                      <SectionRow>
                        <InputContainer label="Teléfono">
                          <PhoneInput
                            required
                            hideExt
                            hideType
                            initialValue={compania?.Telefonos}
                            maxCount={2}
                            onChange={(tels) =>
                              setCompania({
                                ...compania,
                                Telefonos: tels,
                              })
                            }
                          />
                        </InputContainer>
                        <InputContainer label="Correo">
                          <EmailInput
                            required
                            maxCount={1}
                            placeholder="Correo Electrónico"
                            inputValue={compania?.Email}
                            parentCallback={(e) => {
                              setCompania({
                                ...compania,
                                Email: e,
                              });
                            }}
                          />
                        </InputContainer>
                      </SectionRow>
                      <SectionRow>
                        <InputContainer label="Actividad Económica">
                          <ActividadEconomicaLookup
                            placement={canvasPosicion}
                            isInput={false}
                            initialValue={{ value: compania?.ActividadEconomica }}
                            onChange={(e) =>
                              setCompania({
                                ...compania,
                                ActividadEconomica: e.id || e.Id,
                              })
                            }
                          />
                        </InputContainer>
                      </SectionRow>
                    </EditSection>
                    <Direcciones
                      sectionLabel='Dirección'
                      posicionCanvas={canvasPosicion}
                      initialValue={compania?.Direcciones}
                      onChange={(e) => {
                        setCompania((prev) => ({
                          ...prev,
                          Direcciones: e,
                        }));
                      }}
                    />
                    <div className="d-flex pt-4 justify-content-end">
                      <Button pt={ptButton} rounded outlined icon={iconRight} iconPos="right" onClick={(e) => {
                        e.preventDefault()
                        stepperRef.current.nextCallback()
                      }} />
                    </div>
                  </StepperPanel>
                  <StepperPanel pt={ptStepperPanel} header="Configuración de su cuenta">
                    <div className="bootstrapiso">
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        <div
                          style={{
                            background: "rgb(234 234 234)",
                            width: "fit-content",
                            borderRadius: "0.25rem",
                          }}
                        >
                          <Nav
                            variant="pills"
                            defaultActiveKey={pagoAnual ? "pagoAnual" : "pagoMensual"}
                            style={{ padding: "5px", flexWrap: 'nowrap' }}
                          >
                            <Nav.Item>
                              <Nav.Link
                                className='d-flex'
                                style={{
                                  transition: "500ms cubic-bezier(0.35, 0, 0.25, 1)",
                                }}
                                onClick={(e) => {
                                  e.preventDefault();
                                  setPagoAnual(false);
                                }}
                                eventKey="pagoMensual"
                              >
                                Pago Mensual
                              </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                              <Nav.Link
                                style={{
                                  transition: "500ms cubic-bezier(0.35, 0, 0.25, 1)",
                                }}
                                className='d-flex align-items-center'
                                onClick={(e) => {
                                  e.preventDefault();
                                  setPagoAnual(true);
                                }}
                                eventKey="pagoAnual"
                              >
                                Pago Anual
                                <span style={{ marginLeft: '3px', color: "#1e90ff" }}>
                                  {" "}
                                  -10%
                                </span>
                              </Nav.Link>
                            </Nav.Item>
                          </Nav>
                        </div>
                        <div
                          className="card mb-4 shadow-sm mt-3"
                          style={{ minWidth: "25%", }}
                        >
                          <div className="card-header">
                            <h4 className="my-0 font-weight-normal">Subtotal</h4>
                          </div>
                          <div className="card-body d-flex flex-column">
                            <h1 className="card-title pricing-card-title" style={{ fontSize: '1.5rem' }}>
                              {pagoAnual
                                ? `RD$${Citrus.Convert.toCurrencyNoSimbolo(
                                  montoAnual
                                )}`
                                : `RD$${Citrus.Convert.toCurrencyNoSimbolo(
                                  subTotal
                                )}`}
                              <small  >
                                {pagoAnual
                                  ? ` / anual`
                                  : " / mes"}
                              </small>
                            </h1>
                            <span className='text-muted' style={{ fontSize: '20px' }}>
                              {pagoAnual ? (
                                `Ahorro total RD$${Citrus.Convert.toCurrencyNoSimbolo(
                                  Math.abs(descuentoAnual) ?? 0
                                )}`
                              ) : (
                                EsReferido && (
                                  `Ahorro total RD$${Citrus.Convert.toCurrencyNoSimbolo(
                                    Math.abs(montDescuentoReferencia) ?? 0
                                  )}`
                                )
                              )}
                            </span>
                          </div>
                        </div>
                      </div>
                      <EditSection mb='2' title="Indique la cantidad de licencias que desea:">
                        <Row>
                          <Col>
                            <div>
                              <label
                                style={{ display: "block" }}
                                htmlFor="licencias-erp"
                              >
                                Citrus ERP
                              </label>
                              <InputNumber
                                pt={{
                                  incrementButton: { style: { background: "#fcbf494f", color: "#ff7b00", WebkitBorderTopRightRadius: '6px' } },
                                  decrementButton: { style: { background: "#fcbf494f", color: "#ff7b00", WebkitBorderBottomRightRadius: '6px' } },
                                }}
                                inputId="licencias-erp"
                                value={compania.licencias ?? 0}
                                onValueChange={(e) => {
                                  e.preventDefault();
                                  setCompania({
                                    ...compania,
                                    licencias: e.value,
                                    licenciasPT: e.value > 0? 1 :0
                                  })
                                }}
                                mode="decimal"
                                showButtons
                                min={0}
                                max={100}
                              />
                            </div>
                          </Col>
                          <Col>
                            <div>
                              <label style={{ display: "block" }} htmlFor="licencias-pt"> Citrus PT Comercios</label>
                              <InputNumber
                                pt={{
                                  incrementButton: { style: { background: "#fcbf494f", color: "#ff7b00", WebkitBorderTopRightRadius: '6px' } },
                                  decrementButton: { style: { background: "#fcbf494f", color: "#ff7b00", WebkitBorderBottomRightRadius: '6px' } },
                                }}
                                inputId="licencias-pt"
                                value={compania.licenciasPT ?? 0}
                                onValueChange={(e) => {
                                  e.preventDefault();
                                  setCompania({
                                      ...compania,
                                      licenciasPT: e.value
                                  })
                                }}
                                mode="decimal"
                                showButtons
                                min={0}
                                max={100}
                                readOnly
                              />
                              <p style={{ fontStyle: "italic", color:"red" }}>Licencia gratuita por 30 días</p>
                            </div>
                          </Col>
                          <Col >
                            <div>
                              <label
                                style={{ display: "block" }}
                                htmlFor="licencias-crm"
                              >
                                Citrus CRM
                              </label>
                              <InputNumber
                                pt={{
                                  incrementButton: { style: { background: "#fcbf494f", color: "#ff7b00", WebkitBorderTopRightRadius: '6px' } },
                                  decrementButton: { style: { background: "#fcbf494f", color: "#ff7b00", WebkitBorderBottomRightRadius: '6px' } },
                                }}
                                inputId="licencias-crm"
                                value={compania.licenciasCRM ?? 0}
                                onValueChange={(e) => {
                                  e.preventDefault();
                                  setCompania({
                                    ...compania,
                                    licenciasCRM: e.value
                                  })
                                }}
                                mode="decimal"
                                showButtons
                                min={0}
                                max={100}
                              />
                            </div>
                          </Col>
                        </Row>
                      </EditSection>
                      <EditSection mb='2' style={{ marginTop: "2rem" }} title="Seleccione los módulos adicionales que desea incluir en su cuenta">
                        <Row>
                          <Col>
                            <SelectButton
                              pt={ptSelectButton}
                              className="d-flex"
                              value={modulosAdicionales}
                              onChange={(e) => {
                                setCompania({
                                  ...compania,
                                  UsaNomina: e.value.some((item) => item === 1),
                                  UsaConsulta: e.value.some((item) => item === 2),
                                  UsaFactoring: e.value.some((item) => item === 3),
                                  UsaPosRestaurante: e.value.some((item) => item === 4),
                                  UsaPrestamo: e.value.some((item) => item === 5)
                                })
                                setModulosAdicionales(e.value)
                              }}
                              options={modulosAdi}
                              optionLabel="name"
                              multiple
                            />
                          </Col>
                        </Row>
                        {compania.UsaPosRestaurante && (
                          <Row>
                            <Col>
                              <div style={{ marginTop: '15px' }}>
                                <label>Dispositivos Adicionales</label>
                                <SelectButton
                                  pt={ptSelectButton}
                                  className="d-flex"
                                  value={cantidadDispositivosPosRestaurante}
                                  onChange={(e) => {
                                    setCompania({
                                      ...compania,
                                      CantidadDispositivosPosRestaurante: e.value
                                    })
                                    setCantidadDispositovsPosRestaurante(e.value)
                                  }}
                                  options={CantidadTabletasPOSResturante}
                                  optionLabel="name"
                                />
                              </div>
                            </Col>
                          </Row>
                        )}
                      </EditSection>
                      <EditSection mb='2' style={{ marginTop: "2rem" }} title="Seleccione las distintas integraciones que desea incluir en su cuenta">
                        <Row className='mb-3'>
                          <Col className='d-flex'>
                            <div>
                              <div>
                                <label htmlFor="int-dgii">DGII</label>
                                <SelectButton
                                  pt={{
                                    button: { style: { border: "1px solid #ff7b00", color: "#ff7b00", borderRadius: '6px' } }
                                  }}
                                  className="d-flex"
                                  id="int-dgii"
                                  value={intDgii[0]}
                                  onChange={(e) => {
                                    setCompania({
                                      ...compania,
                                      FacturacionElectronica: e.value === 1,
                                      UsaImpresoraFiscal: e.value === 2
                                    })
                                    setIntDgii([e.value])
                                  }}
                                  options={integracionesDgii}
                                  optionLabel="name"
                                />
                                {compania.FacturacionElectronica && (
                                  <div style={{ marginTop: '15px' }}>
                                    <label htmlFor="planes-FE">Planes</label>
                                    <Select
                                      className="basic-single"
                                      classNamePrefix="select"
                                      name="Planes"
                                      onChange={(e) => {
                                        setCompania({
                                          ...compania,
                                          TipoPlanEcf: e.value
                                        })
                                        setTipoPlan([e.value])
                                      }}
                                      options={PLANES_ECF}
                                      value={
                                        esNuevo && !compania?.TipoPlanEcf
                                          ? PLANES_ECF.filter(function (option) {
                                            return option.value === "1kT";
                                          })
                                          : PLANES_ECF.filter(function (option) {
                                            return option.value === (compania?.TipoPlanEcf || '1kT');
                                          })
                                      }
                                    />
                                  </div>
                                )}
                              </div>

                            </div>
                          </Col>
                          <Col className='d-flex'>
                            <div>
                              <label htmlFor="int-panelFirma">Panel de Firma</label>
                              <SelectButton
                                pt={{
                                  button: { style: { border: "1px solid #ff7b00", color: "#ff7b00", padding: '0.75rem 0.75rem' } }
                                }}
                                className="d-flex"
                                id="int-panelFirma"
                                value={intPanelFirma[0]}
                                onChange={(e) => {
                                  setCompania({
                                    ...compania,
                                    UsaModuloVisaNet: e.value === 2,
                                    UsaModuloAzul: e.value === 3,
                                    UsaModuloCardNet: e.value === 1
                                  })
                                  setIntPanelFirma([e.value])
                                }}
                                options={integracionesPanelFirma}
                                optionLabel="name"
                              />
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col className='d-flex'>
                            <div>
                              <label htmlFor="int-comericoElectronico">
                                Comercio Electrónico
                              </label>
                              <SelectButton
                                pt={ptSelectButton}
                                className="d-flex"
                                id="int-comericoElectronico"
                                value={intComercioElectronico[0]}
                                onChange={(e) => {
                                  setCompania({
                                    ...compania,
                                    UsaShopify: e.value === 2,
                                    UsaWooCommerce: e.value === 1
                                  })
                                  setIntComercionElectronico([e.value])
                                }}
                                options={integracionComernioElectronico}
                                optionLabel="name"
                              />
                            </div>
                          </Col>
                          <Col className='d-flex'>
                            <div>
                              <label htmlFor="int-linkPago">Enlace de Pago</label>
                              <SelectButton
                                className="d-flex"
                                id="int-linkPago"
                                value={intLinkPago[0]}
                                onChange={(e) => {
                                  setCompania({
                                    ...compania,
                                    UsaCardNetEnLinea: e.value === 1
                                  })
                                  setIntLinkPago([e.value])
                                }}
                                options={integracionLinkPago}
                                optionLabel="name"
                                pt={{
                                  button: { style: { border: "1px solid #ff7b00", color: "#ff7b00", borderRadius: '6px' } }
                                }}
                              />
                            </div>
                          </Col>
                        </Row>
                      </EditSection>
                    </div>
                    <div className="d-flex pt-4 justify-content-between">
                      <Button pt={ptButton} rounded outlined severity="secondary" icon={iconLeft} onClick={(e) => {
                        e.preventDefault()
                        stepperRef.current.prevCallback()
                      }} />
                      <Button pt={ptButton} rounded outlined icon={iconRight} iconPos="right" onClick={(e) => {
                        e.preventDefault()
                        stepperRef.current.nextCallback()
                      }} />
                    </div>
                  </StepperPanel>
                  <StepperPanel pt={ptStepperPanel} header="Otras configuraciones">
                    <div className="bootstrapiso">
                      <EditSection mb='2' title="Seleccione otras configuraciones libre de costo">
                        <SelectButton
                          pt={ptSelectButton}
                          id="otrasConfig"
                          className="d-flex"
                          value={otrasConfiguraciones}
                          onChange={(e) => {
                            setCompania({
                              ...compania,
                              UsaCaja: e.value.some((item) => item === 1),
                              UsaCentro: e.value.some((item) => item === 2)
                            })
                            setOtrasConfiguraciones(e.value)
                          }}
                          options={otrasConfig}
                          optionLabel="name"
                          multiple
                        />
                      </EditSection>
                      <EditSection mb='2' style={{ marginTop: "2rem" }} title="Logo y Colores">
                        <SectionRow>
                          <InputContainer label="Logo">
                            <DropZone
                              key={dropZoneKey}
                              styles={{ marginLeft: "0px" }}
                              label="Dé click o arrastre la Imagen para continuar"
                              updateFilesCb={onFileChange}
                              multiple={false}
                              maxSize={2097152}
                              type="image"
                              files={compania.Files || []}
                              useVideo={false}
                            />
                          </InputContainer>
                          <InputContainer label="Colores del menu">
                            <ColorPicker
                              value={compania.Color1 ?? 'F16101'}
                              onChange={(e) =>
                                setCompania({
                                  ...compania,
                                  Color1: e.value,
                                })
                              }
                            />
                          </InputContainer>
                        </SectionRow>
                      </EditSection>
                    </div>
                    <div className="d-flex pt-4 justify-content-between">
                      <Button pt={ptButton} rounded outlined severity="secondary" icon={iconLeft} onClick={(e) => {
                        e.preventDefault()
                        stepperRef.current.prevCallback()
                      }} />
                      <Button pt={ptButton} rounded outlined icon={iconRight} iconPos="right" onClick={(e) => {
                        e.preventDefault()
                        stepperRef.current.nextCallback()
                      }} />
                    </div>
                  </StepperPanel>
                  <StepperPanel pt={ptStepperPanel} header="Información para facturar el servicio">
                    <EditSection mb='2' title="Información General del Cliente">
                      <SectionRow>
                        <InputContainer label="Documento">
                          <RncLookup
                            required
                            placement={canvasPosicion}
                            isInput={false}
                            initialValue={{ value: compania?.DocumentoCliente }}
                            onChange={(e) =>
                              setCompania({
                                ...compania,
                                DocumentoCliente: e.value,
                                NombreCliente: e.nombre,
                                TipoDocumentoCliente: e.value.length === 11 ? 'C' : e.value.length === 9 ? 'R' : 'P'
                              })
                            }
                          />
                        </InputContainer>
                        <ControlledInput
                          required
                          label="Nombre"
                          name="NombreCliente"
                          type="text"
                          setState={setCompania}
                          value={compania?.NombreCliente || ""}
                        />
                      </SectionRow>
                      <SectionRow >
                        <InputContainer label="Comprobante Fiscal">
                          <Select
                            className="basic-single"
                            classNamePrefix="select"
                            name="Comprabante Fiscal"
                            onChange={(e) =>
                              setCompania({
                                ...compania,
                                clienteTipo: e.value,
                              })
                            }
                            options={TIPO_NCF_DO}
                            value={
                              esNuevo && !compania?.clienteTipo
                                ? TIPO_NCF_DO.filter(function (option) {
                                  return option.value === "C";
                                })
                                : TIPO_NCF_DO.filter(function (option) {
                                  return option.value === (compania?.clienteTipo || 'C');
                                })
                            }
                          />
                        </InputContainer>
                      </SectionRow>
                    </EditSection>
                    <EditSection mb='2' mt='4' title="Persona Responsable">
                      <SectionRow>
                        <ControlledInput
                          required
                          label="Nombre"
                          name="NombreCobro"
                          type="text"
                          setState={setCompania}
                          value={compania?.NombreCobro || ""}
                        />
                        <ControlledInput
                          required
                          label="Apellidos"
                          name="ApellidosCobro"
                          type="text"
                          setState={setCompania}
                          value={compania?.ApellidosCobro || ""}
                        />
                      </SectionRow>
                      <SectionRow>
                        <InputContainer label="Teléfono">
                          <PhoneInput
                            hideExt
                            required
                            hideType
                            initialValue={compania?.TelefonoCobro}
                            maxCount={2}
                            onChange={(tels) =>
                              setCompania({
                                ...compania,
                                TelefonoCobro: tels,
                              })
                            }
                          />
                        </InputContainer>
                        <InputContainer label="Correo">
                          <EmailInput
                            required
                            placeholder="Correo Electrónico"
                            inputValue={compania?.CorreoCobro}
                            parentCallback={(e) => {
                              setCompania({
                                ...compania,
                                CorreoCobro: e,
                              });
                            }}
                          />
                        </InputContainer>
                      </SectionRow>
                    </EditSection>
                    <div className="d-flex pt-4 justify-content-between">
                      <Button pt={ptButton} rounded outlined severity="secondary" icon={iconLeft} onClick={(e) => {
                        e.preventDefault()
                        stepperRef.current.prevCallback()
                      }} />
                      <Button pt={ptButton} rounded outlined icon={iconRight} iconPos="right" onClick={(e) => {
                        e.preventDefault()
                        stepperRef.current.nextCallback()
                      }} />
                    </div>
                  </StepperPanel>
                  <StepperPanel pt={ptStepperPanel} header="Resumen del servicio contratado">
                    <div style={{ marginBottom: '10px' }} className="flex pt-4 justify-content-start">
                      <EditSection mb='2' title="Detalles del servicio adquirido">
                        <SectionRow alignItems >
                          <div className="list-group" style={{ marginBottom: '15px' }}>
                            {compania.licencias > 0 && (
                              <a
                                href="#"
                                className="list-group-item list-group-item-action"
                              >
                                <div className="d-flex w-100 justify-content-between">
                                  <h5 className="mb-1" style={{ width: '70%', display: 'flex', flexDirection: 'column' }}>
                                    x{compania.licencias} Licencias ERP
                                  </h5>
                                  <small>RD$ {Citrus.Convert.toCurrencyNoSimbolo(COSTO_LICENCIA * compania.licencias)}</small>
                                </div>
                              </a>
                            )}
                            {compania.licenciasCRM > 0 && (
                              <a
                                href="#"
                                className="list-group-item list-group-item-action"
                              >
                                <div className="d-flex w-100 justify-content-between">
                                  <h5 className="mb-1" style={{ width: '70%', display: 'flex', flexDirection: 'column' }}>
                                    x{compania.licenciasCRM} Licencias CRM
                                  </h5>
                                  <small>RD$ {Citrus.Convert.toCurrencyNoSimbolo(COSTO_LICENCIA * compania.licenciasCRM)}</small>
                                </div>
                              </a>
                            )}
                            {modulosAdicionales.map((modulo) => {
                              const selectedModulo = modulosAdi.find(
                                (mod) => mod.value === modulo
                              );
                              if (selectedModulo) {
                                return (
                                  <a
                                    href="#"
                                    className="list-group-item list-group-item-action"
                                    key={selectedModulo.value}
                                  >
                                    <div className="d-flex w-100 justify-content-between">
                                      <h5 className="mb-1" style={{ width: '70%', display: 'flex', flexDirection: 'column' }}>
                                        Modulo {selectedModulo.name}
                                        {selectedModulo.value === 4 && (
                                          <>
                                            <small className='text-muted'>• Pt camarero: 2 tabletas </small>
                                            <small className='text-muted'>• Servicio de Impresion: 1 estacion</small>
                                          </>
                                        )}
                                      </h5>
                                      <small>RD$ {Citrus.Convert.toCurrencyNoSimbolo(COSTO_MODULOS_ADICIONALES)}</small>
                                    </div>
                                  </a>
                                );
                              } else {
                                return null;
                              }
                            })}
                            {cantidadDispositivosPosRestaurante !== null &&
                              cantidadDispositivosPosRestaurante > 0 &&
                              compania.UsaPosRestaurante &&
                              (() => {
                                const selectPlan = CantidadTabletasPOSResturante.find(
                                  (plan) => plan.value === cantidadDispositivosPosRestaurante
                                );

                                return selectPlan ? (
                                  <a
                                    href="#"
                                    className="list-group-item list-group-item-action"
                                    key={selectPlan.value}
                                  >
                                    <div className="d-flex w-100 justify-content-between">
                                      <h5
                                        className="mb-1"
                                        style={{ width: "70%", display: "flex", flexDirection: "column" }}
                                      >
                                        {selectPlan.name}{" "}
                                        <small className="text-muted">Dispositivos Adicionales</small>
                                      </h5>
                                      <small>RD$ {Citrus.Convert.toCurrencyNoSimbolo(selectPlan.precio)}</small>
                                    </div>
                                  </a>
                                ) : null;
                              })()}
                            {intDgii.map((modulo) => {
                              const selectedModulo = integracionesDgii.find(
                                (mod) => mod.value === modulo
                              );
                              if (selectedModulo) {
                                return (
                                  <>
                                    <a
                                      href="#"
                                      className="list-group-item list-group-item-action"
                                      key={selectedModulo.value}
                                    >
                                      <div className="d-flex w-100 justify-content-between">
                                        <h5 className="mb-1" style={{ width: '70%', display: 'flex', flexDirection: 'column' }}>
                                          Integracion {selectedModulo.name}{selectedModulo.value === 1 && (<small className='text-muted'>Pago unico</small>)}
                                        </h5>
                                        {selectedModulo.value === 1 ? (
                                          <small>RD$ {Citrus.Convert.toCurrencyNoSimbolo(COSTO_MODULOS_ADICIONALES * 10)}</small>
                                        ) : (
                                          <small>RD$ {Citrus.Convert.toCurrencyNoSimbolo(COSTO_MODULOS_ADICIONALES)}</small>
                                        )}
                                      </div>
                                    </a>
                                    {selectedModulo.value === 2 && (
                                      <a
                                        href="#"
                                        className="list-group-item list-group-item-action"
                                        key={selectedModulo.value}
                                      >
                                        <div className="d-flex w-100 justify-content-between">
                                          <h5 className="mb-1" style={{ width: '70%', display: 'flex', flexDirection: 'column' }}>
                                            Instalacion remota {selectedModulo.name} <small className='text-muted'>Pago unico</small>
                                          </h5>
                                          <small>RD${Citrus.Convert.toCurrencyNoSimbolo(4000)}</small>
                                        </div>
                                      </a>
                                    )}
                                  </>
                                );
                              } else {
                                return null;
                              }
                            })}
                            {tipoPlan.map((tipo) => {
                              const selectedModulo = PLANES_ECF.find(
                                (mod) => mod.value === tipo
                              );
                              if (selectedModulo && intDgii[0] === 1) {
                                return (
                                  <a
                                    href="#"
                                    className="list-group-item list-group-item-action"
                                    key={selectedModulo.value}
                                  >
                                    <div className="d-flex w-100 justify-content-between">
                                      <h5 className="mb-1" style={{ width: '70%', display: 'flex', flexDirection: 'column' }}>
                                        Plan de {selectedModulo.label} <small className='text-muted'>Facturacion Electronica</small>
                                      </h5>
                                      <small>RD$ {Citrus.Convert.toCurrencyNoSimbolo(selectedModulo.precio)}</small>
                                    </div>
                                  </a>
                                );
                              } else {
                                return null;
                              }
                            })}
                            {intComercioElectronico.map((modulo) => {
                              const selectedModulo =
                                integracionComernioElectronico.find(
                                  (mod) => mod.value === modulo
                                );
                              if (selectedModulo) {
                                return (
                                  <a
                                    href="#"
                                    className="list-group-item list-group-item-action"
                                    key={selectedModulo.value}
                                  >
                                    <div className="d-flex w-100 justify-content-between">
                                      <h5 className="mb-1" style={{ width: '70%', display: 'flex', flexDirection: 'column' }}>
                                        Integracion {selectedModulo.name}
                                      </h5>
                                      <small>RD$ {Citrus.Convert.toCurrencyNoSimbolo(COSTO_MODULOS_ADICIONALES)}</small>
                                    </div>
                                  </a>
                                );
                              } else {
                                return null;
                              }
                            })}
                            {intPanelFirma.map((modulo) => {
                              const selectedModulo = integracionesPanelFirma.find(
                                (mod) => mod.value === modulo
                              );
                              if (selectedModulo) {
                                return (
                                  <>
                                    <a
                                      href="#"
                                      className="list-group-item list-group-item-action"
                                      key={selectedModulo.value}
                                    >
                                      <div className="d-flex w-100 justify-content-between">
                                        <h5 className="mb-1" style={{ width: '70%', display: 'flex', flexDirection: 'column' }}>
                                          Pandel de firma {selectedModulo.name}
                                        </h5>
                                        <small>RD$ {Citrus.Convert.toCurrencyNoSimbolo(COSTO_MODULOS_ADICIONALES)}</small>
                                      </div>
                                    </a>
                                    <a
                                      href="#"
                                      className="list-group-item list-group-item-action"
                                      key={selectedModulo.value}
                                    >
                                      <div className="d-flex w-100 justify-content-between">
                                        <h5 className="mb-1" style={{ width: '70%', display: 'flex', flexDirection: 'column' }}>
                                          Integracion remota {selectedModulo.name} <small className='text-muted'>Pago unico</small>
                                        </h5>
                                        <small>RD$ {Citrus.Convert.toCurrencyNoSimbolo(4000)}</small>
                                      </div>
                                    </a></>
                                );
                              } else {
                                return null;
                              }
                            })}
                            {intLinkPago.map((modulo) => {
                              const selectedModulo = integracionLinkPago.find(
                                (mod) => mod.value === modulo
                              );
                              if (selectedModulo) {
                                return (
                                  <a
                                    href="#"
                                    className="list-group-item list-group-item-action"
                                    key={selectedModulo.value}
                                  >
                                    <div className="d-flex w-100 justify-content-between">
                                      <h5 className="mb-1" style={{ width: '70%', display: 'flex', flexDirection: 'column' }}>
                                        Integracion {selectedModulo.name}
                                      </h5>
                                      <small>RD$ {Citrus.Convert.toCurrencyNoSimbolo(COSTO_MODULOS_ADICIONALES)}</small>
                                    </div>
                                  </a>
                                );
                              } else {
                                return null;
                              }
                            })}
                          </div>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                            }}
                          >
                            <div
                              className="card mb-4 shadow-sm"
                              style={{ width: '100%' }}
                            >
                              <div className="card-header">
                                <h4 className="my-0 font-weight-normal">
                                  Monto a pagar
                                </h4>
                              </div>
                              <div className="card-body">
                                <div className='d-flex justify-content-between'>
                                  <h1 className="card-title pricing-card-title" style={{ fontSize: '1.5rem' }}>
                                    Subtotal:
                                  </h1>
                                  <h1 className="card-title pricing-card-title" style={{ fontSize: '1.5rem' }}>
                                    {pagoAnual
                                      ? ` RD$${Citrus.Convert.toCurrencyNoSimbolo(
                                        (montoAnual + pagosUnicos + Math.abs(descuentoAnual)) ?? 0
                                      )}`
                                      : ` RD$${Citrus.Convert.toCurrencyNoSimbolo(
                                        (subTotal + pagosUnicos + Math.abs(montDescuentoReferencia)) ?? 0
                                      )}`}
                                  </h1>
                                </div>
                                <div className='d-flex justify-content-between'>
                                  <h1 className="card-title pricing-card-title" style={{ fontSize: '1.5rem' }}>
                                    Descuento:
                                  </h1>
                                  <h1 className="card-title pricing-card-title" style={{ fontSize: '1.5rem' }}>
                                    {pagoAnual ? (
                                      `RD$${Citrus.Convert.toCurrencyNoSimbolo(
                                        Math.abs(descuentoAnual) ?? 0
                                      )}`
                                    ) : (
                                      EsReferido ? (
                                        `RD$${Citrus.Convert.toCurrencyNoSimbolo(
                                          Math.abs(montDescuentoReferencia ?? 0)
                                        )}`
                                      ) : (
                                        `RD$${Citrus.Convert.toCurrencyNoSimbolo(
                                          descuentoCantidadLicencias
                                        )}`
                                      )
                                    )}
                                  </h1>
                                </div>
                                <div className='d-flex justify-content-between'>
                                  <h1 className="card-title pricing-card-title" style={{ fontSize: '1.5rem' }}>
                                    Impuestos:
                                  </h1>
                                  <h1 className="card-title pricing-card-title" style={{ fontSize: '1.5rem' }}>
                                    {pagoAnual
                                      ? ` RD$${Citrus.Convert.toCurrencyNoSimbolo(
                                        (pagosUnicos * 0.18)
                                      )}`
                                      : ` RD$${Citrus.Convert.toCurrencyNoSimbolo(
                                        (pagosUnicos * 0.18)
                                      )}`}
                                  </h1>
                                </div>
                                <div className='d-flex justify-content-between'>
                                  <h1 className="card-title pricing-card-title" style={{ fontSize: '1.5rem' }}>
                                    Total:
                                  </h1>
                                  <h1 className="card-title pricing-card-title" style={{ fontSize: '1.5rem' }}>
                                    {pagoAnual
                                      ? ` RD$${Citrus.Convert.toCurrencyNoSimbolo(
                                        montoAnual + pagosUnicos + (pagosUnicos * 0.18)
                                      )}`
                                      : ` RD$${Citrus.Convert.toCurrencyNoSimbolo(
                                        subTotal + pagosUnicos + (pagosUnicos * 0.18)
                                      )}`}
                                  </h1>
                                </div>
                              </div>
                            </div>
                          </div>
                        </SectionRow>
                      </EditSection>
                      <SectionRow alignItems>
                        {tipoPlanReferido !== 2 && (
                          <EditSection mb='2' title="Seleccionar la opcion de pago">
                            <SelectButton
                              pt={{
                                button: { style: { border: "1px solid #ff7b00", color: "#ff7b00", padding: '0.75rem 0.75rem' } }
                              }}
                              className="d-flex"
                              value={tipoPago}
                              options={tiposPago}
                              onChange={(e) => setTipoPago(e.value)}
                              optionLabel='name'
                              id="tipoPago"
                            />
                          </EditSection>
                        )}
                        {EsReferido && (
                          <EditSection mb='2' title="Referido Por">
                            <InputContainer>
                              <Form.Control
                                onChange={(e) =>
                                  FormHelper.handleChange(e, setCompania)
                                }
                                name="ReferidoPor"
                                type="text"
                                value={compania?.ReferidoPor || ReferidoPor}
                                disabled={true}
                              />
                            </InputContainer>
                            <small className='text-muted d-flex'>
                              <div style={{ color: 'red' }}>*&nbsp;</div> <div style={{ fontWeight: 'bold' }}>Beneficio:&nbsp;</div>{(PLAN_REFERIDO.find((e) => e.value === tipoPlanReferido)).name}
                            </small>
                          </EditSection>
                        )}
                      </SectionRow>
                      <div className="d-flex justify-content-center mt-3" style={{ marginBottom: '10px' }} >
                        <Button pt={{ root: { style: { borderRadius: '6px' } } }} label='Aceptar' style={{ width: orientation === 'vertical' ? '-webkit-fill-available' : '200px', fontSize: 'larger' }} onClick={(e) => {
                          handleTipoDePago(e)
                        }} />
                      </div>
                      <Button pt={ptButton} rounded outlined severity="secondary" icon={iconLeft} onClick={(e) => {
                        e.preventDefault()
                        stepperRef.current.prevCallback()
                      }} />
                    </div>
                  </StepperPanel>
                </Stepper>

              )}
            </div>
          </Form>
        </Container>
      </div>
    )
  }
  return <>{page()}</>;
}
export function FormalizarWithLoading() {
  return getComponentWithLoading(Formalizar)();
}
